import { render, staticRenderFns } from "./clients.vue?vue&type=template&id=72ab5be6&scoped=true"
import script from "./clients.vue?vue&type=script&lang=js"
export * from "./clients.vue?vue&type=script&lang=js"
import style0 from "./clients.vue?vue&type=style&index=0&id=72ab5be6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ab5be6",
  null
  
)

export default component.exports